import React from "react";
import moment from "moment/moment";
import {AppBar, Box, Container, IconButton, Toolbar} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PTOCalendar from "./PTOCalendar";
import SlideDatepicker from "./SlideDatepicker";

export default function PTORequest(props) {
  const limitDate = moment(new Date().toLocaleDateString()).format("yyyy-MM");
  const [state, setState] = React.useState({
    date: props.date > limitDate ? props.date : moment(new Date().toLocaleDateString()).add(1, "months").format("yyyy-MM"),
    stopRender: true,
    data: null
  });

  return (
    <Container
      maxWidth = "sm"
      sx = {{padding: 2, pt: 0, flexGrow: 1}}
    >
      <Box
        position = "sticky"
        sx = {{top: 0, zIndex: 1}}
      >
        <AppBar
          className = "bgcolor-white"
          position = "static"
        >
          <Toolbar
            sx = {{p: 0}}
          >
            <IconButton
              aria-label = "menu"
              color = "default"
              onClick = {() => document.getElementById("request_leave_btn").click()}
              size = "small"
              sx = {{ml: "auto"}}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </Box>
      <Box
        className = "bgcolor-white"
        position = "sticky"
        sx = {{top: 55, pt: 2, pb: 2, textAlign: "center", zIndex: 1}}
      >
        <SlideDatepicker
          setState = {setState}
          state = {state}
          ymdFg = {false}
        />
      </Box>
      {new Date(state.date + "-01").toLocaleDateString() !== "Invalid Date" &&
        <PTOCalendar
          parentSetState = {props.setState}
          parentState = {props.state}
          setToastState = {props.setToastState}
          state = {state}
          toastState = {props.toastState}
        />
      }
    </Container>
  );
};
